
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Grupo 4984"}},[_c('path',{attrs:{"data-name":"Retângulo 1382","fill":"none","d":"M0 0h20v20H0z"}}),_c('g',{attrs:{"data-name":"icons8-star-filled (1)"}},[_c('path',{attrs:{"data-name":"Caminho 558","d":"M19 7.979l-6.386-.671L10 1.441 7.386 7.308 1 7.982l4.77 4.3-1.334 6.276 5.562-3.208 5.562 3.208-1.332-6.28z","fill":"none","stroke":"rgba(61,61,61,0.75)","stroke-linejoin":"round","stroke-width":"1.75"}})])])])
          )
        }
      }
    